import { toast } from 'react-toastify';
import { ErrorMsg } from '@/components/shared/toast';


export const showToast = (e: string) => {
  toast(<ErrorMsg text={e} />);
};
